export const SUPPORTED_LANGUAGES = {
  English: 'en',
  Français: 'fr',
};

export enum MIME_TYPE {
  JSON = 'application/json',
}

export enum REQUEST_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum ROLES {
  OYO_ADMIN = 'OYO_Admin',
  PMO = 'PMO',
  CONSUMER = 'Consumer',
  PRODUCER = 'Producer',
  NO_ROLE = '',
}

export enum COUNTRY {
  FRANCE = 'fr',
}

export const DATE_FORMAT = 'DD/MM/YYYY';

export const PREVIEW_TEXT_LENGHT = 455;

export const SCREEN_CONTENT_SIZE = '1380px';

export const DATE_FORMAT_TYPE = 'YYYY-MM-DD';

export const MONTH_FORMAT_TYPE = 'YYYY-MM';

export enum MenuItemType {
  MyFeed = 'myFeed',
  MyCommunity = 'myCommunity',
  CollectiveSelfConsumptions = 'collectiveSelfConsumptions',
  Messages = 'messages',
  AppFeedbacks = 'appFeedbacks',
  NewestAndRecent = 'newestAndRecent',
  PopularOfDay = 'popularOfDay',
}

export const API_URLS = {
  TOPICS: '/topics',
  REACTION: '/reaction',
  VOTE: '/vote',
  VOTE_CHECK: '/vote/check',
  VOTE_RESULTS: '/vote/vote_results',
  TOPICS_CATEGORY: '/topics_category',
  CATEGORY: 'category',
  RECENT_PINNED: 'recent_pinned',
  POLL: '/poll',
  STOP_POLL: '/poll/stop_poll',
  MEETING: '/meeting',
  SUMMARY: 'summary',
  PINNED_COMMUNITY: 'pinned_community',
  UNPINNED_COMMUNITY: 'unpinned_community',
  GET_COMMUNITY: '/community',
};

export enum POST_TYPE {
  TOPIC = 'topic',
  MEET = 'meet',
  POLL = 'poll',
}

export enum PROTOCOLE {
  HTTP = 'http:',
  HTTPS = 'https:',
}
